import React from 'react';
import styled from 'styled-components';

import { icons } from './index';

import { ICONS } from '@controlrooms/constants';

interface Props extends React.ButtonHTMLAttributes<HTMLDivElement> {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
  rotate?: number;
  variant?: 'primary' | 'secondary' | 'tertiary';
}

export const StyledIcon = styled.div<Props>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  display: flex;
  align-items: center;
  ${({ rotate }) => {
    if (rotate) {
      return `
        transform: rotate(${rotate}deg);
      `;
    }
  }}
  & svg {
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
    height: ${({ height }) => (height ? `${height}px` : 'auto')};
    path {
      fill: ${({ color, theme, variant }) => {
        if (color) return color;
        if (variant === 'primary') return theme.icon.primary;
        if (variant === 'secondary') return theme.icon.secondary;
        if (variant === 'tertiary') return theme.icon.tertiary;
        return theme.icon.secondary;
      }};
    }
    circle {
      fill: ${({ color, theme, variant }) => {
        if (color) return color;
        if (variant === 'primary') return theme.icon.primary;
        if (variant === 'secondary') return theme.icon.secondary;
        if (variant === 'tertiary') return theme.icon.tertiary;
        return theme.icon.secondary;
      }};
    }
  }
`;

interface Props {
  className?: string;
  color?: string;
  name: typeof ICONS[keyof typeof ICONS];
  width?: string;
  height?: string;
  rotate?: number;
  variant?: 'primary' | 'secondary' | 'tertiary';
}

export const Icon: React.FC<Props> = ({
  name,
  width,
  height,
  color,
  rotate,
  variant,
  className,
  ...props
}) => {
  const IconComp = icons[name];

  if (!IconComp) return null;

  return (
    <StyledIcon
      name={name}
      color={color}
      className={className}
      width={width}
      height={height}
      rotate={rotate}
      variant={variant}
      {...props}
    >
      <IconComp className={`${name}-icon`} />
    </StyledIcon>
  );
};
